import React, { useMemo } from "react";
import NewsList from "./NewsList";
import WatchlistNewsHeader from "./WatchlistNewsHeader";
import { useTickersFilter } from "./useTickersFilter";
import type { TickerItem } from "./types";
import { useWatchlistNews } from "~hooks/useWatchlistNews";
import { useCurrentWatchlist } from "~context/WatchlistContext";

export default function WatchlistNewsV2() {
  const currentWatchlist = useCurrentWatchlist();

  const { tickerItems, positionsMap, allTickerString } = useMemo(() => {
    const positions = currentWatchlist?.positions ?? [];
    const items: TickerItem[] = positions.map((position) => ({
      ticker: position.ticker,
      companyName: position.marketData?.longName ?? position.ticker,
    }));
    const map = new Map<string, number>();

    for (const position of positions) {
      map.set(position.ticker, position.marketData?.percentChange1Day ?? 0);
    }

    return {
      tickerItems: items,
      positionsMap: map,
      allTickerString: items.map((t) => t.ticker).join(","),
    };
  }, [currentWatchlist?.positions]);

  const { allSelected, selectedTickers, activeTickers, toggleTicker } =
    useTickersFilter(tickerItems);

  const { items, isLoading, error, retry } = useWatchlistNews(
    allTickerString,
    positionsMap
  );

  const filteredItems = useMemo(() => {
    if (allSelected) return items;

    const activeSet = new Set(activeTickers);

    return items.filter((item) =>
      item.tickers.some((t) => activeSet.has(t.symbol))
    );
  }, [items, allSelected, activeTickers]);

  return (
    <div>
      <WatchlistNewsHeader
        tickers={tickerItems}
        allSelected={allSelected}
        selectedTickers={selectedTickers}
        onToggleTicker={toggleTicker}
      />
      <NewsList
        items={filteredItems}
        isLoading={isLoading}
        error={error}
        onRetry={retry}
      />
    </div>
  );
}
